export default {
  data () {
    return {
      showNewNpiGrouping: false
    }
  },
  methods: {
    showCreateNpiModal () {
      this.showNewNpiGrouping = true
    },
    npiGroupCreated (key, group) {
      var npiGroupKeys = group
      npiGroupKeys['npi_group_name'] = key
      var npiGroup = {
        dataType: 'npi',
        draggable: true,
        edit_type: 'created',
        height: 0,
        id: 'created',
        key: key,
        map_type: 'group',
        name: 'group',
        path: 1 + '.' + this.pathCount,
        required: false,
        template_id: this.trainTemplateData.id,
        uniq_id: (Date.now()).toString(),
        width: 0,
        x: 0,
        x_pos: 0,
        y: 0,
        y_pos: 0,
        npi_group: npiGroupKeys
      }
      this.mappingsSaveData.push(npiGroup)
      var fields = Object.keys(group)
      fields.map((field) => {
        if (group[field] !== null) {
          this.mappingsSaveData.map(previousMappings => {
            if (previousMappings.key === group[field] && previousMappings.map_type !== 'group') {
              previousMappings.path = npiGroup.path + '.' + previousMappings.path.split('.').pop()
            }
          })
        }
      })
      this.pathCount++
      this.saveData()
      this.showNewNpiGrouping = false
    },
    npiGroupCancelled () {
      this.showNewNpiGrouping = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/npiGroupMappings.js